module.exports = __webpack_public_path__ + "static/preview-292cf86d57891df6b95a4030be9a09d0.png";